import { cn } from '@1trading/react';
import { Star } from 'lucide-react';

import { AppTile } from '@/components/dashboard/app-tile';
import { EnvIndicator } from '@/components/dashboard/env-meta';
import type { CatalogApp } from '@/types/catalog';

type AppRowProps = {
  app: CatalogApp;
  isPinned: boolean;
  onTogglePin: (appId: string) => void;
};

export const AppRow = ({ app, isPinned, onTogglePin }: AppRowProps) => (
  <div className="group relative flex items-center gap-3 rounded-xl px-4 py-3 transition-colors hover:bg-muted/40">
    <a href={app.launchUrl} target="_blank" rel="noreferrer" className="absolute inset-0 rounded-xl focus-visible:outline-2 focus-visible:outline-ring">
      <span className="sr-only">Open {app.label}</span>
    </a>
    <AppTile abbr={app.abbr} color={app.color} icon={app.icon} label={app.label} />
    <div className="min-w-0 flex-1">
      <p className="truncate font-medium text-sm">{app.label}</p>
      <p className="truncate text-muted-foreground text-xs">{app.description}</p>
    </div>
    {app.environment && <EnvIndicator environment={app.environment} />}
    <button
      type="button"
      onClick={() => onTogglePin(app.id)}
      aria-label={isPinned ? `Unpin ${app.label}` : `Pin ${app.label}`}
      aria-pressed={isPinned}
      className={cn(
        'relative z-10 rounded-md p-1.5 transition-colors focus-visible:outline-2 focus-visible:outline-ring',
        isPinned ? 'text-primary' : 'text-muted-foreground/70 hover:text-foreground',
      )}
    >
      <Star className={cn('size-4', isPinned && 'fill-current')} aria-hidden />
    </button>
  </div>
);
